import React from 'react';
import type { AccountState } from '../../types/admin';
const tone: Record<AccountState, string> = {
  active: 'bg-healthy-soft text-healthy-ink border-healthy-border',
  past_due: 'bg-critical-soft text-critical-ink border-critical-border',
  trialing: 'bg-brand-soft text-brand-ink border-brand-border',
  cancelled: 'bg-paused-soft text-paused-ink border-paused-border'
};
const label: Record<AccountState, string> = {
  active: 'Active',
  past_due: 'Past due',
  trialing: 'Trialing',
  cancelled: 'Cancelled'
};
export function AccountStateBadge({
  state
}: {
  state: AccountState;
}) {
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${tone[state]}`} data-id="element-54" data-mp="3ptsn2p3gx19">
      {label[state]}
    </span>;
}